var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rodemap"},[_c('div',{staticClass:"mask05"}),_c('QuestionSelect',{attrs:{"data":_vm.data},on:{"jump":_vm.jump,"finish":_vm.finish}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }